import Vue from 'vue'
// \r 转 <br/>
const textToHtml = (text) => {
    return text ? text.replace(/\r\n/ig, '<br/>') : '';
}

export default () => {
    Vue.prototype.$textToHtml = textToHtml
}